/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable no-useless-concat */
/**
 * Layout related methods
 * -----------------------------------------------------------------------------
 *
 * @namespace layout
 */

import enquire from 'enquire.js';
import detectIt from 'detect-it';
import tinycolor from 'tinycolor2';
import Flickity from 'flickity';
import videojs from 'video.js';
import selectpicker from 'bootstrap-select';
import 'videojs-youtube/dist/Youtube.min.js';
import 'video.js/dist/video-js.min.css';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';
import axios from 'axios';

var createHistory = require('history').createBrowserHistory;

var history = createHistory();

var videoPlayer = null;

var layoutMethods = {
	data: function data() {
		return {
			scrollPosition: 0,
			isLogoLight: false,
			isOverlayVisible: false,
			isCartDrawerOpen: false,
			isMobileNavDrawerOpen: false,
			isSearchLayerOpen: false,
			isNewsletterPopupOpen: false
		};
	},


	methods: {
		_initLayout: function _initLayout() {
			window.addEventListener('scroll', app._checkScrollPos); // add scroll event listener
			window.addEventListener('resize', app._initStickyHeader); // add resize event listener
			// make all images in RTE editor load via lazyload
			$('.rte img').addClass('lazyload');

			app._initBootstrapComponents();
			app._initNewsletterPopup();
			app._initStickyHeader();
			app._initCarousels();
			app._checkScrollPos();
			app._checkCurrencyElements();

			// init videos
			if ($('.video-js').length > 0) {
				videojs(document.querySelector('.video-js'));
			}
		},

		/**
		 * Window scroll info => update classes & elements
		 */
		_initBootstrapComponents: function _initBootstrapComponents() {
			/* Bootstrap components that need to be initialized should be called here */
			// init popover
			$('[data-toggle="popover"]').popover();

			// cart dropdown popover
			$('[data-cart-dropdown]').popover({
				html: true,
				content: function content() {
					return $(this).next('[data-cart-dropdown-content]').html();
				}
			});

			// init tooltip but only for desktop
			if (!detectIt.hasTouch) {
				setTimeout(function () {
					$('[data-toggle="tooltip"]').tooltip();
				}, 100);
			}

			// make navigation drop-downs open on mouse hover instead of click
			$('.navbar a[data-toggle="dropdown"]').on('mouseenter', function (e) {
				var $dropdownLink = $(this).parent();
				var $dropdownMenu = $dropdownLink.find('.dropdown-menu');

				$dropdownLink.addClass('show');
				$dropdownMenu.addClass('show');

				$dropdownLink.on('mouseleave', function (e) {
					$(this).removeClass('show');
					$dropdownMenu.removeClass('show');
				});
			});

			// make also the top link clickable
			$('.navbar a[data-toggle="dropdown"]').on('click', function (e) {
				location.href = $(this).attr('data-href');
			});
		},
		_initNewsletterPopup: function _initNewsletterPopup() {
			var customerPosted = window.location.href.search('[?&]customer_posted=true') !== -1;
			var $newsletterPopup = $(app.selectors.newsletterPopup);
			var popupDelay = $newsletterPopup.data('popup-delay') * 1000;
			var daysUntil = $newsletterPopup.data('period-until');
			var newsletterPopupEnabled = $newsletterPopup.data('newsletter-enabled');
			var newsletterPopupStatus = app._getCookie('newsletter_popup_status');
			var today = new Date();
			var expirationDate = new Date();
			expirationDate.setDate(today.getDate() + daysUntil);
			var time = expirationDate.getTime();
			var expireTime = time + 1000 * 36000;
			expirationDate.setTime(expireTime);

			// after registration get the 'customer_posted' parameter from URL
			// show popup after successful registration
			// the popup will have the 'Thank you' message after registration redirection
			if (customerPosted) {
				app._toggleNewsletterPopup();
			}

			// do not show the popup if the disabled status cookie exists
			if (newsletterPopupStatus === 'disabled' || !newsletterPopupEnabled) {
				return;
			}

			setTimeout(function () {
				app._toggleNewsletterPopup();
			}, popupDelay);

			$(document).on('click', '[data-newsletter-close-btn]', function () {
				document.cookie = "newsletter_popup_status=disabled;expires=" + expirationDate.toGMTString() + ";path=/";
			});
		},
		_initStickyHeader: function _initStickyHeader() {
			var $siteHeader = $(app.selectors.siteHeader);
			var $headerSlider = $(app.selectors.headerSlider);
			var $mainNav = $siteHeader.find('nav');
			var $topBar = $siteHeader.find('[data-top-bar]');
			var $mainBar = $siteHeader.find('[data-main-bar]');
			var navHeight = void 0;

			if ($topBar.length > 0) {
				navHeight = $mainNav.outerHeight() + $topBar.outerHeight() + $mainBar.outerHeight();
			} else {
				navHeight = $mainNav.outerHeight();
			}

			if ($siteHeader.data('fixed-header')) {
				// boolean
				$('body #app').css('padding-top', navHeight);
			} else {
				$headerSlider.css('height', $headerSlider.outerHeight() - navHeight);
			}
		},


		/**
		 * Window scroll info => update classes & elements
		 */
		_getParameterByName: function _getParameterByName(name) {
			name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
			var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
			var results = regex.exec(location.search);
			console.log(name, "rex==>", regex, "result==>", results);

			return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
		},
		_checkScrollPos: function _checkScrollPos() {
			var $siteHeader = $(app.selectors.siteHeader);
			var $mainNav = $siteHeader.find('nav');
			var $topBar = $siteHeader.find('[data-top-bar]');
			var $navBgColor = $mainNav.css('backgroundColor');
			var isHeaderTransparent = $siteHeader.data('transparent-header');
			var isHomepage = $('body').hasClass('template-index');
			var isSearchPage = $('body').hasClass('template-search');
			var windowScrollY = window.scrollY;
			var isDarkBg = void 0;
			var navHeight = void 0;
			if (isSearchPage === false) {
				if ($topBar.length > 0) {
					navHeight = $mainNav.outerHeight() + $topBar.outerHeight();
				} else {
					navHeight = $mainNav.outerHeight();
				}

				if (app.scrollPosition < windowScrollY && app.scrollPosition > navHeight) {
					// direction down
					$('body').removeClass('is-scrolled-top is-scrolled-up').addClass('is-scrolled-down');
					isDarkBg = tinycolor($navBgColor).isDark(); // returns boolean

					if (isDarkBg) {
						app.isLogoLight = true;
					} else {
						app.isLogoLight = false;
					}
				} else {
					// direction up
					$('body').removeClass('is-scrolled-top is-scrolled-down').addClass('is-scrolled-up');
					if (isHomepage && isHeaderTransparent) {
						$mainNav.removeClass('bg-transparent');
					}
					isDarkBg = tinycolor($navBgColor).isDark(); // returns boolean

					if (isDarkBg) {
						app.isLogoLight = false;
					}
				}

				if (windowScrollY <= navHeight) {
					// reached top
					$('body').removeClass('is-scrolled-up').addClass('is-scrolled-top');

					if (isHomepage && isHeaderTransparent) {
						$mainNav.addClass('bg-transparent');
						app.isLogoLight = true;
					}
				}
				// hide popover past to 200
				// if (app.scrollPosition > 200){
				//   app.$root.$emit('bv::hide::popover')
				// }
				app.scrollPosition = windowScrollY;
			}
		},
		_initCarousels: function _initCarousels() {
			var $carousel = $(app.selectors.carousel);
			var videoPlayerSlider = void 0;

			$carousel.each(function (index, el) {
				var flkty = Flickity.data(el); // pass in the element, $element[0], not the jQuery object
				if (flkty === undefined || typeof flkty === 'undefined') {
					return;
				}

				var totalSlides = flkty.cells.length;
				var selectedSlide = flkty.selectedElement;
				var slideType = $(selectedSlide).data('slide-type');

				if (totalSlides === 1) {
					$(el).addClass('hide-nav-ui');
				}

				flkty.on('settle', function () {
					selectedSlide = flkty.selectedElement;
					slideType = $(selectedSlide).data('slide-type');
					checkVideo(slideType);
				});

				flkty.on('change', function (index) {
					if (videoPlayerSlider) {
						videoPlayerSlider.pause();
					}
					// $('[data-carousel-main] iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
					$('[data-carousel-main] iframe').attr('src', $('[data-carousel-main] iframe').attr('src'));
				});

				function checkVideo(slideType) {
					if (slideType !== 'video') {
						return;
					}
					videoPlayerSlider = videojs($(selectedSlide).find('.video-js')[0]);
					videoPlayerSlider.play();
				}

				checkVideo(slideType);
				flkty.resize();
				app._triggerResize();
			});
		},
		_initVideo: function _initVideo(selectedSlide) {
			var $selectedVideo = $(selectedSlide).find('[data-video-slide]');
			var selectedVideoId = $selectedVideo.data('video-id');

			if (!selectedVideoId) {
				return;
			}

			function onPlayerReady(e) {
				e.target.setPlaybackQuality('hd720');
				e.target.mute();
				e.target.playVideo();
			}

			function onPlayerStateChange(e) {
				if (e.data === YT.PlayerState.ENDED) {
					// console.log('video finished');
				}
			}

			enquire.register('screen and (min-width: 720px)', {
				match: function match() {
					YouTubeIframeLoader.load(function (YT) {
						videoPlayer = new YT.Player($selectedVideo[0], {
							videoId: selectedVideoId,
							width: '100%',
							height: '100%',
							playerVars: {
								enablejsapi: 1,
								autoplay: 1,
								loop: 1,
								playlist: selectedVideoId, // otherwise loop will not work
								rel: 0,
								controls: 0,
								showinfo: 0,
								modestbranding: 0,
								disablekb: 1
								// 'start': 0,
								// 'end': 335,
							},
							events: {
								onReady: onPlayerReady,
								onStateChange: onPlayerStateChange
							}
						});
					});
				},
				unmatch: function unmatch() {
					if (videoPlayer) {
						videoPlayer.destroy();
					}
				}
			});
		},


		/**
		 * Event when variant quantity selector changes
		 */
		_updateQty: function _updateQty(event) {
			var $qtyEl = $(event.currentTarget).parentsUntil(app.selectors.qtyContainer).find(app.selectors.qtyInput);
			var qtyValue = $qtyEl.val();
			var $item = $(event.currentTarget).closest(app.selectors.cartItem);
			var variantId = $item.data('variant-id');
			var cartProduct = app.cart.items.find(function (x) {
				return x.variant_id === variantId;
			});
			var productCartLimit = $item.data('cart-limit');

			if ($(event.currentTarget).data('qty-decrease') !== undefined) {
				if (parseFloat(qtyValue) >= 2) {
					qtyValue = parseFloat(qtyValue) - 1;
				}
			} else if ($(event.currentTarget).data('qty-increase') !== undefined) {
				qtyValue = parseFloat(qtyValue) + 1;

				// check if item has product limit assigned
				if (app.currentTemplate === 'cart' && app._productHasCartLimit(qtyValue, productCartLimit)) {
					return;
				}
			}

			$qtyEl.val(qtyValue);
		},


		/**
		 * Event for toggling the cart drawer
		 *
		 */
		_toggleCartDrawer: function _toggleCartDrawer() {
			if (app.currentTemplate === 'cart') {
				return;
			}

			var $siteOverlay = $(app.selectors.siteOverlay);
			var cartType = $(app.selectors.siteHeader).data('cart-type');

			// stop parsing if cart type is not set to 'drawer'
			if (cartType !== 'cart_drawer') {
				return;
			}

			if (!app.isCartDrawerOpen) {
				// open drawer
				app.isOverlayVisible = true;
				app._lockScroll();

				// re-init tooltips but only for desktop
				if (!detectIt.hasTouch) {
					$('[data-toggle="tooltip"]').tooltip();
				}
			} else {
				app.isOverlayVisible = false;
				app._unlockScroll();
			}

			// toggle the status data
			app.isCartDrawerOpen = !app.isCartDrawerOpen;

			$siteOverlay.on('click', function () {
				if (app.isSearchLayerOpen) {
					return;
				}
				app._toggleCartDrawer();
			});

			$(document).on('keydown', function (e) {
				// close drawer
				if (!app.isCartDrawerOpen) {
					return;
				}
				e = e || window.event;
				if (e.keyCode === 27) {
					app._toggleCartDrawer();
				}
			});
		},


		/**
		 * Event for toggling the mobile menu drawer
		 *
		 */
		_toggleMobileNavDrawer: function _toggleMobileNavDrawer() {
			var $siteOverlay = $(app.selectors.siteOverlay);

			if (!app.isMobileNavDrawerOpen) {
				// open drawer
				app.isOverlayVisible = true;
				app._lockScroll();
			} else {
				app.isOverlayVisible = false;
				app._unlockScroll();
			}

			// toggle the status data
			app.isMobileNavDrawerOpen = !app.isMobileNavDrawerOpen;

			$siteOverlay.on('click', function () {
				if (!app.isMobileNavDrawerOpen) {
					return;
				}
				app._toggleMobileNavDrawer();
			});
		},


		/**
		 * Event for toggling the search layer
		 *
		 */
		_toggleSearch: function _toggleSearch() {
			var $searchLayer = $(app.selectors.searchLayer);
			var searchType = $searchLayer.data('search-type');
			var $inputSearch = $searchLayer.find('#searchInput_layer');

			if (!app.isSearchLayerOpen) {
				$inputSearch.val('');
				app._lockScroll();

				if (searchType === 'full_screen') {
					$('header, footer, section').addClass('filter-blur').css('opacity', '0.5');
					$('[data-product-toolbar-mobile]').hide();
				} else {
					app.isOverlayVisible = true;
				}

				setTimeout(function () {
					$inputSearch.focus();
				}, 500);
			} else {
				$inputSearch.blur();
				app._unlockScroll();

				if (searchType === 'full_screen') {
					$('header, footer, section').removeClass('filter-blur').css('opacity', '1');
					$('[data-product-toolbar-mobile]').show();
				} else {
					app.isOverlayVisible = false;
				}
			}

			// toggle the status data
			app.isSearchLayerOpen = !app.isSearchLayerOpen;

			$(document).on('keydown', function (e) {
				// close drawer
				if (!app.isSearchLayerOpen) {
					return;
				}
				e = e || window.event;
				if (e.keyCode === 27 && app.isSearchLayerOpen) {
					app._toggleSearch();
				}
			});
		},


		/**
		 * Event for toggling the newsletter popup
		 *
		 */
		_toggleNewsletterPopup: function _toggleNewsletterPopup() {
			if (!app.isNewsletterPopupOpen) {
				app._lockScroll();
				app.isOverlayVisible = true;
			} else {
				app._unlockScroll();
				app.isOverlayVisible = false;
			}

			// toggle the status data
			app.isNewsletterPopupOpen = !app.isNewsletterPopupOpen;
		},


		/**
		 * Lock window scroll
		 *
		 */
		_lockScroll: function _lockScroll() {
			$('html').css('overflow', 'hidden');

			$(document).on('touchmove', function (e) {
				if (!$(e.target).closest('[data-touch-moveable]').length) {
					e.preventDefault();
				}
			});
		},


		/**
		 * Unlock window scroll
		 *
		 */
		_unlockScroll: function _unlockScroll() {
			$('html').css('overflow', 'auto');
			$(document).unbind('touchmove');
		},
		_changeCurrency: function _changeCurrency() {
			var $currencyForm = $('[data-currency-selector]');
			$currencyForm[0].submit();
		},

		_selectWishlistProduct: function _selectWishlistProduct(handle) {
			app.selectWishlistProduct = false;
			app.iswishlistPopup = !app.iswishlistPopup;
			axios.get("/products/" + handle + ".js")
				// eslint-disable-next-line promise/always-return
				.then(function (response) {
					app.selectedForwishlist = response.data;
					app._getCurrentWishlist(app.selectedForwishlist.id, app.selectedForwishlist.variants[0].id);
				}).catch(function (error) {
					throw error;
				});
		},
		_openWishlistpopUp: function _openWishlistpopUp(handle) {
			app.iswishlistPopup = true;
			app._selectWishlistProduct(handle);
			setTimeout(function () {
				$('#wishlistModal').modal({ show: true });
			}, 500);
		},
		_closeWishlistModal: function _closeWishlistModal() {
			app.iswishlistPopup = !app.iswishlistPopup;
			app.iswishlistlist = false;
			app.isListFormOpen = true;
			// console.log($('.creatlistCheckBox'))
			// $('.creatlistCheckBox').attr('checked', '');
			$('[data-wishlistmodal]').modal('hide');
		},
		_backbutton: function _backbutton() {
			history.goBack();
		}
	}
};

export default layoutMethods;